import removeMd from 'remove-markdown'

export const stripMarkdown = (s) => removeMd(s)
